import React from 'react'

import ReactDOM from 'react-dom/client'

import App from './App'

import {
  discoverExtensions,
} from './platform/extensions/discovery'

import {
  LayoutProvider,
} from './platform/preferences/LayoutContext'

import {
  ContextualSettingsProvider,
} from './platform/contextual/ContextualSettingsContext'

import {
  ActivityProvider,
} from './platform/activity/ActivityContext'

discoverExtensions()

ReactDOM
  .createRoot(
    document.getElementById(
      'root',
    )!,
  )
  .render(
    <React.StrictMode>

      <LayoutProvider>

        <ContextualSettingsProvider>

          <ActivityProvider>

            <App />

          </ActivityProvider>

        </ContextualSettingsProvider>

      </LayoutProvider>

    </React.StrictMode>,
  )
